<template>
  <div>
    <!-- Header -->
    <AppHeader />

    <!-- Hero Section -->
    <section class="hero hero-eastern" v-if="category">
      <div class="container">
        <div class="hero-content fade-in-up">
          <h1>{{ category.name }}</h1>
          <p v-if="category.description">{{ category.description }}</p>
        </div>
      </div>
    </section>

    <!-- Loading state -->
    <section class="hero hero-eastern" v-else-if="loading">
      <div class="container">
        <div class="hero-content fade-in-up">
          <h1>Загрузка...</h1>
        </div>
      </div>
    </section>

    <!-- Error state -->
    <section class="hero hero-eastern" v-else-if="error">
      <div class="container">
        <div class="hero-content fade-in-up">
          <h1>Ошибка</h1>
          <p>{{ error }}</p>
        </div>
      </div>
    </section>

    <!-- Main Content -->
    <UISection v-if="category" :title="null" class="no-title">
      <template #default>
        <CoursesList :category-id="category.id" :title="null" />
      </template>
    </UISection>

    <!-- Footer -->
    <AppFooter />
  </div>
</template>

<script>
import axios from 'axios';
import AppHeader from '../components/AppHeader.vue';
import AppFooter from '../components/ui/UIFooter.vue';
import UISection from '../components/ui/UISection.vue';
import CoursesList from '../components/CoursesList.vue';

export default {
  name: 'CategoryCourses',
  components: {
    AppHeader,
    AppFooter,
    UISection,
    CoursesList
  },
  data() {
    return {
      category: null,
      loading: true,
      error: null
    };
  },
  mounted() {
    this.loadCategory();
  },
  watch: {
    '$route.params.slug'() {
      this.loadCategory();
    }
  },
  methods: {
    async loadCategory() {
      this.loading = true;
      this.error = null;
      try {
        const slug = this.$route.params.slug;
        const response = await axios.get(`/api/v1/public/product-categories/${slug}`);
        this.category = response.data;
      } catch (error) {
        console.error('Ошибка при загрузке категории:', error);
        if (error.response?.status === 404) {
          this.error = 'Категория не найдена или недоступна';
        } else {
          this.error = 'Ошибка при загрузке категории';
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
/* Hero Section */
.hero {
  background: linear-gradient(135deg, #e63946 0%, #d62839 100%);
  color: white;
  padding: 80px 20px;
  text-align: center;
}

.hero-eastern {
  background: linear-gradient(135deg, #e63946 0%, #d62839 100%),
              url('https://images.unsplash.com/photo-1548013146-72479768bada?w=1600') center/cover;
  background-blend-mode: overlay;
}

.hero-content {
  max-width: 800px;
  margin: 0 auto;
}

.hero h1 {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 16px;
  animation: fadeInUp 0.8s ease;
}

.hero p {
  font-size: 20px;
  opacity: 0.95;
  animation: fadeInUp 1s ease;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in-up {
  animation: fadeInUp 0.8s ease;
}

/* Responsive */
@media (max-width: 768px) {
  .hero h1 {
    font-size: 32px;
  }

  .hero p {
    font-size: 16px;
  }
}
</style>

